import { z } from 'zod/v3';
import { createPaginationSchema } from '../../common/utils/schema';
import {
  DataObjectGroupProcessingStateSchema,
  DataVersionStatusSchema,
} from '../../input-data/schema/DataObjectGroupProcessingStateSchema';

export const OutputDataObjectGroupProcessingStateSchema =
  DataObjectGroupProcessingStateSchema.extend({
    outputTypeId: z.number().int().nullable(),
    latestDataObjectVersionId: z.number().int().nullable(),
    versionStatus: DataVersionStatusSchema.nullable(),
    version: z.string().nullable(),
    versionConfirmed: z.boolean(),
    processingStateCode: z.string().nullable(),
    versionValidationErrorLevelId: z.number().int().nullable(),
    calculationErrors: z.boolean(),
    missingSourceData: z.boolean(),
  });

export const OutputDataObjectGroupProcessingStatePageSchema =
  createPaginationSchema(OutputDataObjectGroupProcessingStateSchema);
